// Códigos de serviço da NF que a Hydrodata usa — LISTA ÚNICA da tela (04/10/2026).
//
// Eram três cópias (cadastro de serviço, parcela do Contas a Receber e
// reorganizador do contrato). A lista do servidor é
// `dre-sistema/lambda/comercial-engine/handlers/cnaes.js`; o teste
// `tests/catalogo/concordancia.test.js` trava as duas iguais e varre a tela
// atrás de código escrito à mão fora deste arquivo.
export const CNAES: { codigo: string; descricao: string }[] = [
  { codigo: '07.03.01', descricao: 'Estudos/planos de engenharia' },
  { codigo: '07.03.02', descricao: 'Projetos (anteprojeto/básico/executivo)' },
  { codigo: '07.20.02', descricao: 'Topografia terrestre' },
  { codigo: '07.20.03', descricao: 'Batimetria/hidrometria' },
  { codigo: '7119-7/03', descricao: 'Desenho técnico' },
];

// Código padrão de cada área — ponto de partida do cadastro, editável.
export const CNAE_PADRAO_DA_AREA: Record<string, string> = {
  topografia: '07.20.02',
  hidrometria: '07.20.03',
  seguranca_barragem: '07.20.03',
  projeto: '07.03.02',
  consultoria_ambiental: '07.03.01',
  fiscalizacao_projeto: '07.03.01',
};

export const cnaeValido = (codigo?: string | null) => !!codigo && CNAES.some(c => c.codigo === codigo);

export const rotuloCnae = (c: { codigo: string; descricao: string }) => `${c.codigo} — ${c.descricao}`;

// Opções prontas para o Select do antd (busca por código ou por descrição).
export const OPCOES_CNAE = CNAES.map(c => ({ value: c.codigo, label: rotuloCnae(c) }));
